var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52613 5.58424L4.5261 5.5841C4.44347 5.25404 4.56083 4.90578 4.82731 4.69192C5.09308 4.47864 5.45875 4.43978 5.76349 4.59215L19.0173 11.2193L19.0176 11.2194C19.313 11.3669 19.5 11.6691 19.5 12C19.5 12.3309 19.313 12.6331 19.0176 12.7806L19.0173 12.7807L5.76349 19.4079C5.45876 19.5602 5.09308 19.5214 4.82731 19.3081C4.56083 19.0942 4.44347 18.746 4.5261 18.4159L4.52613 18.4158L5.82801 13.2095L13.5344 12.4979V11.5021L5.82801 10.7905L4.52613 5.58424Z",
    fill: "#CF2F92",
    stroke: "#CF2F92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.7bbeec703611ab49c8fe34472c497db9.svg";
export { ForwardRef as ReactComponent };